import React from 'react';
import {Button} from 'antd';
import "./ButtonComponent.scss"

interface ButtonProps {
    className?: string;
    loadingText?: string;
    loading?: boolean;
    gradient?: boolean;// Optional loading text when button is in loading state
    type?: "submit" | "button" | "reset";
    variant?: "outlined" | "dashed" | "solid" | "filled" | "text" | "link";
    color?: "default" | "primary" | "danger";
    disabled?: boolean;
    onClick?: ((event: MouseEvent) => void);
    size?: 'small' | 'middle' | 'large';
    shape?: 'default' | 'circle' | 'round';
    block?: boolean;
    icon?: React.ReactNode;
    iconPosition?:'start' | 'end';
}

const ButtonComponent = (props: React.PropsWithChildren<ButtonProps>) => {
    const {
        loading,
        className,
        gradient,
        loadingText,
        children,
        icon,
        type,
        variant,
        color = 'default' as ButtonProps["color"],
        disabled,
        onClick = undefined,
        size,
        shape,
        block,
        iconPosition
    } = props;

    return (
        <Button
            loading={loading}
            disabled={disabled}
            // icon={loading ? <LoadingOutlined/> : icon}
            //@ts-ignore
            onClick={onClick}
            icon={icon}
            htmlType={type}
            className={`${gradient ? "gradient-button" : ''} ${className}`}
            variant={variant}
            color={color}
            size={size}
            shape={shape}
            block={block}
            iconPosition={iconPosition}
        >
            {loading && loadingText ? loadingText : children}
        </Button>
    );
};

export default ButtonComponent;
